export default ({
  state: {
    ordenesPedidos: [],
    count: 0
  },
  getters: {
    get_pedidos (state) {
      return state.ordenesPedidos
    },
    get_count (state) {
      state.count = state.count + 1
      return state.count
    }
  },
  mutations: {
    SET_PEDIDO (state, pedido) {
      state.ordenesPedidos.push(pedido)
      console.log('PEDIDOS-->> ', state.ordenesPedidos)
    },
    SET_CANCEL (state, item) {
      state.ordenesPedidos.map((a, i) => {
        if (a.id === item.id) {
          a.status = 'Cancelado'
        }
      })
    }
  }
})
